var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isClient())?_c('client-profile'):_c('minimal-profile',{attrs:{"editProfileId":_vm.editdId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }